import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 5);

  if (hotArticles.length === 0) return null;

  const mainArticle = hotArticles[0];
  const sideArticles = hotArticles.slice(1, 5);

  return (
    <section className="py-14 bg-background-100">
      <div className="container-main">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-fire-line text-accent-500 text-lg"></i>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                热门爆料
              </h2>
            </div>
            <p className="text-sm text-foreground-500">全网最受关注的独家爆料</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          <div className="lg:col-span-3">
            <Link
              to={`/article/${mainArticle.id}`}
              className="group block relative rounded-lg overflow-hidden h-[360px]"
            >
              <img
                src={mainArticle.imageHero}
                alt={mainArticle.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                {mainArticle.isExclusive && (
                  <span className="inline-block px-2 py-0.5 mb-3 text-xs font-medium rounded bg-accent-500/90 text-white">
                    独家
                  </span>
                )}
                <h3 className="text-lg md:text-xl font-heading font-bold text-white group-hover:text-primary-200 transition-colors duration-200 line-clamp-2">
                  {mainArticle.title}
                </h3>
                <p className="mt-2 text-sm text-white/60 line-clamp-2">{mainArticle.summary}</p>
                <div className="flex items-center gap-4 mt-3 text-xs text-white/40">
                  <span>{mainArticle.publishDate}</span>
                  <span>{mainArticle.views.toLocaleString()} 阅读</span>
                  <span>{mainArticle.comments.toLocaleString()} 评论</span>
                </div>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {sideArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors duration-200 animate-fade-in-up"
                style={{ animationDelay: `${(idx + 1) * 100}ms` }}
              >
                <div className="shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden">
                  <img
                    src={article.imageThumb}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    {article.isExclusive && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        独家
                      </span>
                    )}
                    <span className="text-[10px] text-foreground-400">{article.category}</span>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h4>
                  <div className="flex items-center gap-3 mt-2 text-[10px] text-foreground-400">
                    <span>{article.publishDate}</span>
                    <span><i className="ri-eye-line mr-0.5"></i>{article.views.toLocaleString()}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}